export default __webpack_public_path__ + "static/media/heart.f9e15d06.svg";